export const CEC_PARTNERS_API_URL = 'ui/organization/cec_partners';

export const cecPartnersQueryKeys = {
  base: [CEC_PARTNERS_API_URL],
};
